import React from 'react'
import { Breadcrumb } from 'react-bootstrap';
import DashboardLayout from '../../components/layouts/dashboardLayout'
import { FaMoneyBillAlt, FaReceipt, FaShoppingCart, FaMoneyBillWaveAlt, FaClipboardList, FaArchive, FaWallet } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import RecentOrders from '../../components/orders/recentOrder';
import SalesChartItem from "../../components/charts/SalesChart"
import moment from 'moment';


function Dashboard() {
   let dashboard = useSelector(data => data.dashboard);
   const cards = [
      { title: "Sales Today", icon: <FaMoneyBillAlt />, value: dashboard?.data?.todaySales?.toLocaleString() || "0" },
      { title: "Sales Yesterday", icon: <FaMoneyBillAlt />, value: dashboard?.data?.yesterdaySales?.toLocaleString() || "0" },
      { title: "Total Sales This Week", icon: <FaMoneyBillAlt />, value: dashboard?.data?.weekSales?.toLocaleString() || "0" },
      { title: "Sales This Month", icon: <FaMoneyBillAlt />, value: dashboard?.data?.monthSales?.toLocaleString() || "0" },
      { title: "Overall Sales", icon: <FaMoneyBillAlt />, value: dashboard?.data?.totalSales?.toLocaleString() || "0" },
   ];

   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-4">
               <div className="row">
                  <div className="col-12">
                     <Breadcrumb>
                        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
                        <Breadcrumb.Item active>Overview</Breadcrumb.Item>
                     </Breadcrumb>
                  </div>
               </div>

               <div className="row g-2">
                  {cards.map((card, index) => (
                     <div key={index} className="col">
                        <div className="card p-3 dashboard-card text-center h-100" style={{ minWidth: "150px" }}>
                           <div className="card-icon">{card.icon}</div>
                           <div className="card-heading text-muted">{card.title} </div>
                           <div className="card-number">{card.value}</div>
                        </div>
                     </div>
                  ))}
               </div>

               <div className="row mt-2">
                  <div className="col-12">
                     <div className="card p-3 dashboard-card text-center h-100">
                        <SalesChartItem
                           todaySalesList={dashboard?.data?.todaySalesList || []}
                           yesterdaySalesList={dashboard?.data?.yesterdaySalesList || []}
                           weekSalesList={dashboard?.data?.weekSalesList || []}
                           monthSalesList={dashboard?.data?.monthSalesList || []}
                        />
                     </div>
                  </div>
               </div>

               <div className='row my-2 '>
                  <div className='col-12'>
                     <RecentOrders />
                  </div>
               </div>

            </div>
         </DashboardLayout>
      </>
   )
}

export default Dashboard